import { useCallback } from "react";
import { useHistory } from 'react-router';
import { Link } from "react-router-dom";

import { requestPassword, submitPassword } from '../controllers/member';
import { showAlert } from '../zeta-widget/tools/alert-tool'

export function ForgotPasswordPage(props) {
  const history = useHistory();

  const handleRequestPassword = useCallback(() => {
    const formdata = new FormData(document.getElementById('requestPwd'));
    const data = Object.fromEntries(formdata);
    requestPassword(data,  (err, result) => {
      if (err) {
        if (typeof err === 'string') {
          showAlert(err, 'danger');
        } else {
          showAlert('ไม่สามารถดำเนินการได้ในขณะนี้<br />\nกรุณาทำรายการอีกครั้ง หลัง 30 นาที', 'danger');
        }
        return;
      }

      showAlert(`รหัสผ่านชั่วคราวส่งไปที่ ${result.email}`);
      document.querySelector('input[name=oldpwd]').focus();
    })
  }, []);

  const handleSubmitPassword = useCallback(() => {
    const reqData = new FormData(document.getElementById('requestPwd'));
    const submitData = new FormData(document.getElementById('submitPwd'));
    submitData.append('email', reqData.get('email'));
    submitData.append('captcha', reqData.get('captcha'));

    const data = Object.fromEntries(submitData);
    submitPassword(data,  (err, result) => {
      if (err) {
        if (typeof err === 'string') {
          showAlert(err, 'danger');
        } else {
          showAlert('ไม่สามารถดำเนินการได้<br />\nกรุณาตรวจสอบข้อมูลอีกครั้ง', 'danger');
        }
        return;
      }

      showAlert(result.message);
      history.push('/login');
    })
  }, [history]);


  const handleResetCaptcha = useCallback(() => {
    const _img = document.getElementById('img_captcha');
    _img.src = '/api/v2/captcha?t=' + new Date().getTime();
  }, []);

  return (
    <div className="row justify-content-center">
      <div className="col-xl-10 col-lg-12 col-md-9">
        <div className="card o-hidden border-0 shadow-lg my-5">
          <div className="card-body p-0">
            {/* Nested Row within Card Body */}
            <div className="row p-3">
              <div className="col-lg-6 d-none d-lg-block bg-password-image"></div>
              <div className="col-lg-6">
                <div className="p-5">
                  <div className="text-center">
                    <h1 className="h4 text-gray-900 mb-2">Forgot Your Password?</h1>
                    <p className="mx-4 mb-4">ขั้นตอนที่ 1 คลิก Send Password <br />
                      โปรแกรมจะส่ง รหัสผ่านชั่วคราวไปที่ Email</p>
                  </div>
                  <form className="user" id="requestPwd">
                    <div className="form-group">
                      <input 
                        type="email" 
                        className="form-control form-control-user" 
                        name="email" 
                        placeholder="Enter Email Address..." />
                    </div>

                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <input
                          type="text"
                          className="form-control form-control-user"
                          name="captcha"
                          placeholder="Secure Code"
                        />                        
                      </div>
                      <div className="col-sm-6">
                        รหัสความปลอดภัยด้านล่าง
                      </div>
                    </div>

                    <button type="button" 
                      className="btn btn-primary btn-user btn-block"
                      onClick={handleRequestPassword}
                    >
                      Send Password
                    </button>

                    <img id="img_captcha" src="/api/v2/captcha" alt="captcha" />
                    <button type="button" className="btn" onClick={handleResetCaptcha}>
                      <i className="fas fa-sync-alt"></i>
                    </button>
                    <p>รหัสความปลอดภัย</p>
                  </form>
                  <hr />
                  <p className="mx-4 my-4 text-center">
                    ขั้นตอนที่ 2 ป้อนรหัสผ่านชั่วคราว <br />
                    และ ป้อน รหัสใหม่ที่ต้องการ
                  </p>
                  <form className="user" id="submitPwd">
                    <div className="form-group">
                      <input name="oldpwd" type="password" id="oldpwd"
                        className="form-control form-control-user" placeholder="Password from email"
                        // onKeyDown={handleKeyDown}
                        autoComplete="off" />
                    </div>

                    <div className="form-group">
                      <input name="newpwd" type="password" id="newpwd"
                        className="form-control form-control-user" placeholder="New Password"
                        // onKeyDown={handleKeyDown}
                        autoComplete="off" />
                    </div>

                    <div className="form-group">
                      <input name="repwd" type="password" id="repwd"
                        className="form-control form-control-user" placeholder="Retype New Password"
                        // onKeyDown={handleKeyDown}
                        autoComplete="off" />
                    </div>

                    <button type="button" 
                      className="btn btn-primary btn-user btn-block"
                      onClick={handleSubmitPassword}
                    >
                      Change Password
                    </button>
                  </form>
                  <hr />
                  <div className="text-center">
                    <Link className="small" to="/register">Create an Account!</Link>
                  </div>
                  <div className="text-center">
                    <Link className="small" to="/login">Already have an account? Login!</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}